import { Link } from 'react-router-dom'

import type { ICardMenuItemProps } from '../interfaces'

export function CardItemMenu({ Icon, route, textCard }: ICardMenuItemProps) {
  return (
    <Link to={route}>
      <div className="w-full h-[148px] bg-white shadow-md flex flex-col items-center justify-center border border-gray-300 rounded-xl">
        <Icon size={48} color="#DA2535" />
        <p className="mt-4">{textCard}</p>
      </div>
    </Link>
  )
}
